/*
 ###################
 ## HighLightedText ##
 ##################
Wrapper for the common HighLighted Text.

 * OPTIONS
 * className[String]: class for the main div.
 * title[String]: title for the text.
 * text[String]: text to show.
 * icon[object]: icon

 * EXAMPLE
     <HighLightedText
        className= "form__textbox"
        title= {formatText('hightLightedText-important')}
        text= {formatText('hightLightedText-jointHolderLegal')}
        icon = {<i className="icons icons--icon-add"></i>}
    />
 */
const React = require('react');

class HighLightedText extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { className, style, title, icon } = this.props;

        return (
            <div className={className} style={style}>
                {icon}
                <div className="message">
                    {title && <h5 className="title">{title}</h5>}
                    <p className="description">{this.props.children}</p>
                </div>
            </div>
        );
    }
}

HighLightedText.defaultProps = {};
module.exports = HighLightedText;
